exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixed-posters-action[data-v-17e4f198]{width:100%;margin-right:auto;margin-left:auto;position:fixed;bottom:0;border-top:1px solid coral;color:#354558;left:0;background-color:#fff}.posters-actions[data-v-17e4f198]{display:flex;align-items:center;padding:15px 2.5vw}@media screen and (max-width:768px){.fixed-posters-action[data-v-17e4f198]{padding-left:0;width:100%}.posters-actions[data-v-17e4f198]{padding:15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17e4f198","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/poster-automation/DraftPostersActions.vue
// module id = Gzx+
// module chunks = 101